import { motion } from 'framer-motion';
import { ChevronDown, Play } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_23aab0a6-b4d8-4ab8-9e19-4bd12735db59/artifacts/25srhfr5_hf_20260202_151914_84ae40de-23f1-4549-8edc-af3ba777d7b1.png')`
        }}
      />
      
      {/* Dark Gradient Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      {/* Neon Glow Effect */}
      <div className="absolute inset-0 hero-glow" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          {/* Tagline */}
          <motion.p 
            className="font-manrope text-sm md:text-base tracking-[0.3em] uppercase text-neutral-400 mb-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.8 }}
          >
            Featuring Roxxie Vayne — The AI Rock Warrior
          </motion.p>
          
          {/* Main Title */}
          <motion.h1 
            className="font-syne font-extrabold tracking-tighter uppercase leading-[0.85] text-[#EDEDED] glitch-hover relative"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            <span className="block text-neon-red text-5xl md:text-7xl lg:text-8xl">Shadowcell</span>
            <span className="block text-3xl md:text-4xl lg:text-5xl -mt-2 md:-mt-4 text-neutral-400">Studios</span>
          </motion.h1>
          
          {/* Roxxie Vayne Feature */}
          <motion.div
            className="mt-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            <p className="font-syne font-bold text-4xl md:text-6xl lg:text-7xl text-white tracking-tight">
              ROXXIE VAYNE
            </p>
          </motion.div>
          
          {/* Subtitle */}
          <motion.p 
            className="font-manrope text-lg md:text-xl text-neutral-300 mt-6 max-w-2xl mx-auto leading-relaxed"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.8 }}
          >
            Cinematic AI-generated promo videos that ignite your music.
            <br />
            <span className="text-neon-red font-bold">30-second promos from just £5.</span>
          </motion.p>
          
          {/* CTA Buttons */}
          <motion.div 
            className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.8 }}
          >
            <button
              data-testid="hero-cta-pricing"
              onClick={() => scrollToSection('pricing')}
              className="btn-primary px-8 py-4 rounded-none font-manrope font-bold text-sm tracking-widest uppercase flex items-center gap-2 neon-glow-hover"
            >
              <Play className="w-4 h-4" />
              View Pricing
            </button>
            <button
              data-testid="hero-cta-contact"
              onClick={() => scrollToSection('contact')}
              className="px-8 py-4 rounded-none font-manrope font-bold text-sm tracking-widest uppercase border border-white/20 text-white hover:border-neon-red hover:text-neon-red transition-colors duration-300"
            >
              Get In Touch
            </button>
          </motion.div>
        </motion.div>
        
        {/* Scroll Indicator */}
        <motion.div 
          className="absolute bottom-10 left-1/2 -translate-x-1/2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, y: [0, 10, 0] }}
          transition={{ 
            opacity: { delay: 1, duration: 0.8 },
            y: { repeat: Infinity, duration: 1.5 }
          }}
        >
          <button 
            onClick={() => scrollToSection('services')}
            className="text-neutral-400 hover:text-neon-red transition-colors duration-300"
            aria-label="Scroll down"
          >
            <ChevronDown className="w-8 h-8" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
